import React from 'react'
import { times } from 'lodash'
import CellMainSkeleton from './CellMainSkeleton'
import CellTitleSkeleton from './CellTitleSkeleton'
import { TableSkeletonType } from '@/plugins/skeleton/types/TableSkeletonType'

const TableLoadBoardSkeleton = ({ numberOfRows }: TableSkeletonType) => (
  <div className="tennders-broker-truckboard-table-row">
    <div></div>
    <CellTitleSkeleton />
    <CellTitleSkeleton />
    <div></div>
    <CellTitleSkeleton />
    <CellTitleSkeleton />
    <CellTitleSkeleton />
    <CellTitleSkeleton />
    <CellTitleSkeleton />
    <CellTitleSkeleton />
    {times(numberOfRows, (i) => (
      <React.Fragment key={i}>
        <CellMainSkeleton type="icon" />
        <CellMainSkeleton type="text" rows={3} />
        <CellMainSkeleton type="text" rows={3} />
        <CellMainSkeleton type="arrow" />
        <CellMainSkeleton type="text" rows={3} />
        <CellMainSkeleton type="text" rows={5} />
        <CellMainSkeleton type="text" rows={1} />
        <CellMainSkeleton type="text" rows={4} />
        <CellMainSkeleton type="icon" rows={1} />
        <CellMainSkeleton type="icon" rows={1} />
      </React.Fragment>
    ))}
  </div>
)

export default React.memo(TableLoadBoardSkeleton)
